import { WarningIcon } from "@phosphor-icons/react/dist/csr/Warning";
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@volca/ui/components/ui/alert";
import type { IAiSpreadsheetRegionOverrideReview } from "@/payroll/ai-script/types";

interface SpreadsheetRegionWorkbookReviewBannerProps {
  reviews: IAiSpreadsheetRegionOverrideReview[];
}

/**
 * Workbook reviews belong to a saved sheet identity that is not present in the
 * current workbook. No active sheet can own them, so they need a workbook notice
 * instead of the candidate controls shown for a loaded sheet.
 */
export const SpreadsheetRegionWorkbookReviewBanner = ({
  reviews,
}: SpreadsheetRegionWorkbookReviewBannerProps) => {
  if (reviews.length === 0) return null;

  return (
    <Alert color="information">
      <WarningIcon className="h-5 w-5" />
      <AlertTitle>Saved tables need setup</AlertTitle>
      <AlertDescription>
        <p>
          These saved tables belong to sheets that are not in this workbook. Set
          them up again if the sheets return.
        </p>
        <ul className="mt-2 list-disc space-y-1 pl-5">
          {reviews.map((review) => (
            <li key={review.id}>
              {review.sheet_name}
              {review.header_values.some(Boolean) && (
                <>: {review.header_values.filter(Boolean).join(", ")}</>
              )}
            </li>
          ))}
        </ul>
      </AlertDescription>
    </Alert>
  );
};
